var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _vm.project
          ? _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.project.Info.title))]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.hasOptionalValues
                    ? _c("div", { staticClass: "donation-values row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-2"
                          },
                          [
                            _c(
                              "a",
                              {
                                class: {
                                  active:
                                    _vm.donationValue ==
                                    _vm.project.optionalValues.optionalValue1
                                },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    _vm.changeDonationValue(
                                      _vm.project.optionalValues.optionalValue1
                                        ? _vm.project.optionalValues
                                            .optionalValue1
                                        : 20
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.project.optionalValues.optionalValue1
                                        ? "R$" +
                                            _vm.project.optionalValues
                                              .optionalValue1
                                        : "R$20"
                                    )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-2"
                          },
                          [
                            _c(
                              "a",
                              {
                                class: {
                                  active:
                                    _vm.donationValue ==
                                    _vm.project.optionalValues.optionalValue2
                                },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    _vm.changeDonationValue(
                                      _vm.project.optionalValues.optionalValue2
                                        ? _vm.project.optionalValues
                                            .optionalValue2
                                        : 25
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.project.optionalValues.optionalValue2
                                        ? "R$" +
                                            _vm.project.optionalValues
                                              .optionalValue2
                                        : "R$25"
                                    )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-2"
                          },
                          [
                            _c(
                              "a",
                              {
                                class: {
                                  active:
                                    _vm.donationValue ==
                                    _vm.project.optionalValues.optionalValue3
                                },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    _vm.changeDonationValue(
                                      _vm.project.optionalValues.optionalValue3
                                        ? _vm.project.optionalValues
                                            .optionalValue3
                                        : 50
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.project.optionalValues.optionalValue3
                                        ? "R$" +
                                            _vm.project.optionalValues
                                              .optionalValue3
                                        : "R$50"
                                    )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-2"
                          },
                          [
                            _c(
                              "a",
                              {
                                class: {
                                  active:
                                    _vm.donationValue ==
                                    _vm.project.optionalValues.optionalValue4
                                },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    _vm.changeDonationValue(
                                      _vm.project.optionalValues.optionalValue4
                                        ? _vm.project.optionalValues
                                            .optionalValue4
                                        : 100
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.project.optionalValues.optionalValue4
                                        ? "R$" +
                                            _vm.project.optionalValues
                                              .optionalValue4
                                        : "R$100"
                                    )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-14 col-lg-4"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "money",
                                  rawName: "v-money",
                                  value: _vm.money,
                                  expression: "money"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.donationValueText,
                                  expression: "donationValueText"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Outro valor"
                              },
                              domProps: { value: _vm.donationValueText },
                              on: {
                                keyup: function($event) {
                                  return _vm.changeDonationValue(null)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.donationValueText = $event.target.value
                                }
                              }
                            })
                          ]
                        )
                      ])
                    : _c("div", { staticClass: "donation-values row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-2"
                          },
                          [
                            _c(
                              "a",
                              {
                                class: { active: _vm.donationValue == 20 },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.changeDonationValue(20)
                                  }
                                }
                              },
                              [_vm._v("R$20")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-2"
                          },
                          [
                            _c(
                              "a",
                              {
                                class: { active: _vm.donationValue == 25 },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.changeDonationValue(25)
                                  }
                                }
                              },
                              [_vm._v("R$25")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-2"
                          },
                          [
                            _c(
                              "a",
                              {
                                class: { active: _vm.donationValue == 50 },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.changeDonationValue(50)
                                  }
                                }
                              },
                              [_vm._v("R$50")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-12 col-lg-2"
                          },
                          [
                            _c(
                              "a",
                              {
                                class: { active: _vm.donationValue == 100 },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.changeDonationValue(100)
                                  }
                                }
                              },
                              [_vm._v("R$100")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-14 col-lg-4"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "money",
                                  rawName: "v-money",
                                  value: _vm.money,
                                  expression: "money"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.donationValueText,
                                  expression: "donationValueText"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Outro valor"
                              },
                              domProps: { value: _vm.donationValueText },
                              on: {
                                keyup: function($event) {
                                  return _vm.changeDonationValue(null)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.donationValueText = $event.target.value
                                }
                              }
                            })
                          ]
                        )
                      ]),
                  _vm._v(" "),
                  _vm.project.Costs && _vm.project.Costs.length > 0
                    ? _c(
                        "div",
                        { staticClass: "donation-values row" },
                        [
                          _c("h4", [
                            _vm._v("Como você pode ajudar este projeto:")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.project.Costs, function(cost, c) {
                            return _c(
                              "div",
                              {
                                key: c,
                                staticClass: "col-md cost",
                                on: {
                                  click: function($event) {
                                    return _vm.changeDonationValueText(
                                      cost.value
                                    )
                                  }
                                }
                              },
                              [
                                _c("span", [_vm._v(_vm._s(cost.title))]),
                                _vm._v(" "),
                                _c("p", [_vm._v("R$ " + _vm._s(cost.value))]),
                                _vm._v(" "),
                                _c("span", { staticClass: "description" }, [
                                  _vm._v(_vm._s(cost.description))
                                ])
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "donation-type" }, [
                    _c("h2", [_vm._v("Escolha o tipo de doação")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "types row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c(
                          "a",
                          {
                            class: { active: _vm.donationType == "single" },
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.changeDonationType("single")
                              }
                            }
                          },
                          [_vm._v("Única")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c(
                          "a",
                          {
                            class: { active: _vm.donationType == "monthly" },
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.changeDonationType("monthly")
                              }
                            }
                          },
                          [_vm._v("Recorrente")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.donationType == "monthly"
                      ? _c("div", { staticClass: "periods row" }, [
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "a",
                              {
                                class: { active: _vm.donationPeriod == 12 },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.changeDonationPeriod(12)
                                  }
                                }
                              },
                              [_vm._v("1 ano")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "a",
                              {
                                class: { active: _vm.donationPeriod == 24 },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.changeDonationPeriod(24)
                                  }
                                }
                              },
                              [_vm._v("2 anos")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "a",
                              {
                                class: { active: _vm.donationPeriod == 36 },
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.changeDonationPeriod(36)
                                  }
                                }
                              },
                              [_vm._v("3 anos")]
                            )
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "donation-form" }, [
                    _c(
                      "form",
                      {
                        attrs: { method: "POST" },
                        on: { submit: _vm.makeDonation }
                      },
                      [
                        _c("div", { staticClass: "form-group col-md-6" }, [
                          _c("label", [_vm._v("Seu nome")]),
                          _vm._v(" "),
                          _vm.user
                            ? _c("input", {
                                staticClass: "form-control",
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: _vm.user.Info
                                    ? _vm.user.Info.fullname
                                    : _vm.user.username
                                }
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.name,
                                    expression: "name"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { required: "", type: "text" },
                                domProps: { value: _vm.name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.name = $event.target.value
                                  }
                                }
                              }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.donationAnonymous,
                                  expression: "donationAnonymous"
                                }
                              ],
                              attrs: { id: "anonymous", type: "checkbox" },
                              domProps: {
                                value: true,
                                checked: Array.isArray(_vm.donationAnonymous)
                                  ? _vm._i(_vm.donationAnonymous, true) > -1
                                  : _vm.donationAnonymous
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.donationAnonymous,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = true,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.donationAnonymous = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.donationAnonymous = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.donationAnonymous = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "anonymous" } }, [
                              _vm._v("Doação anônima")
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group col-md-6" }, [
                          _c("label", [_vm._v("E-mail")]),
                          _vm._v(" "),
                          _vm.user && !_vm.user.isFacebookUser
                            ? _c("input", {
                                staticClass: "form-control",
                                attrs: { type: "text", readonly: "" },
                                domProps: { value: _vm.user.Info.email }
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.email,
                                    expression: "email"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { required: "", type: "text" },
                                domProps: { value: _vm.email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.email = $event.target.value
                                  }
                                }
                              }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.donationNewsletter,
                                  expression: "donationNewsletter"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: true,
                                checked: Array.isArray(_vm.donationNewsletter)
                                  ? _vm._i(_vm.donationNewsletter, true) > -1
                                  : _vm.donationNewsletter
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.donationNewsletter,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = true,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.donationNewsletter = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.donationNewsletter = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.donationNewsletter = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(
                              "\n                  Assine nossa newsletter e ajude a fazer a diferença\n                "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group col-md-12" }, [
                          _c("label", [
                            _vm._v("Mensagem para o projeto (opcional)")
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.donationMessage,
                                expression: "donationMessage"
                              }
                            ],
                            staticClass: "form-control",
                            domProps: { value: _vm.donationMessage },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.donationMessage = $event.target.value
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _vm.showMsg
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "alert alert-danger alert-dismissible fade show",
                                attrs: { role: "alert" }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.msg) +
                                    "\n                  "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "close",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "alert",
                                      "aria-label": "Fechar"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.hideMsg()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("×")]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(1)
                      ]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-tab" }, [
      _c("ul", [
        _c("li", { staticClass: "active" }, [_vm._v("1 - Quanto quero doar")]),
        _vm._v(" "),
        _c("li", [_vm._v("2 - Meios de pagamento")]),
        _vm._v(" "),
        _c("li", [_vm._v("3 - Compartilhar")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn-payment" }, [
      _c("button", { staticClass: "btn" }, [_vm._v("Fazer pagamento")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65f18ec2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f18ec2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Donation.vue
// module id = null
// module chunks = 